var React = require('react');

function Sent (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#FFF","d":"M.002 7.447a.81.81 0 00.407.756l5.286 3.006 7.237-6.141-6.148 7.237 3.006 5.286a.81.81 0 00.693.409h.054a.81.81 0 00.693-.502l6.71-16.384A.81.81 0 0016.886.06L.504 6.75a.81.81 0 00-.502.696z"}));
}

Sent.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18"};

module.exports = Sent;

Sent.default = Sent;
